// @flow
import { createActions } from 'redux-actions'

export type InteractionCapabilitiesActions =
  | { type: 'INTERACTION_CAPABILITIES/TOUCH/SET', payload: boolean }
  | { type: 'INTERACTION_CAPABILITIES/HOVER/SET', payload: boolean }

const actionCreators = createActions({
  INTERACTION_CAPABILITIES: {
    TOUCH: {
      SET: undefined
    },
    HOVER: {
      SET: undefined
    }
  }
})

export default actionCreators
